import React from "react";
import DefaultCurrencyFormat from "../../DefaultCurrencyFormat";
import { useTranslation } from "../../../context/TranslationContext";
import { renderToString } from "react-dom/server";

const Title = ({ paymentDetails }) => {
  const { PayByCreditCardTitle, PayByCreditCardCaption } = useTranslation();
  return (
    <div className="flex flex-col mb-9">
      <span
        className="text-15 font-bold text-text-rezervation-form leading-5"
        dangerouslySetInnerHTML={{
          __html: PayByCreditCardTitle.replace(
            "{price}",
            renderToString(
              <DefaultCurrencyFormat
                value={paymentDetails.tutar}
                Symbol={paymentDetails.Symbol}
              />
            )
          ),
        }}
      ></span>
      <span className="sm:text-[1.875rem] text-25 font-bold leading-10	text[#333738]">
        {PayByCreditCardCaption}
      </span>
    </div>
  );
};

export default Title;
